import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Database, Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "./ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LegacyImport = ({ headers, toast }) => {
  const [st, setSt] = useState(null);
  const [password, setPassword] = useState("");
  const [replace, setReplace] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => axios.get(`${API}/admin/legacy-import/status`, { headers }).then((r) => setSt(r.data)).catch(() => {}), [headers]);
  useEffect(() => { load(); }, [load]);
  const running = st?.state === "importing" || st?.state === "copying";
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [running, load]);

  const start = async () => {
    if (!window.confirm(replace ? "Eski sitedeki firmalar aktarılacak ve şu anki diğer firmalar silinecek (yedek alınır). Devam edilsin mi?" : "Eski sitedeki firmalar aktarılacak. Devam edilsin mi?")) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/legacy-import`, { password, replace }, { headers });
      toast({ title: "Aktarım başladı", description: `${r.data.inserted} firma eklendi. Fotoğraflar arka planda kopyalanıyor.` });
      setPassword("");
      load();
    } catch (e) {
      toast({ title: "Hata", description: e?.response?.data?.detail || "Aktarım başlatılamadı." });
    }
    setBusy(false);
  };

  const pct = st?.imagesTotal ? Math.round((((st.imagesDone || 0) + (st.imagesFailed || 0)) / st.imagesTotal) * 100) : 0;
  return (
    <div className="bg-white rounded-2xl border border-[#F0DDE0] p-6" data-testid="legacy-import-card">
      <h2 className="font-display text-2xl text-[#2A2224] flex items-center gap-2"><Database className="w-6 h-6 text-[#9E2A3B]" /> Eski Siteden Aktar</h2>
      <p className="text-sm text-[#7C6E70] mt-2 max-w-2xl">Eski dugunsenin.com veritabanındaki firmalar (açıklama, fiyat, kapasite, özellikler ve fotoğraflar) tek seferde aktarılır. Aktif firmalar yayında, kapalılar <b>Beklemede</b> gelir. Fotoğraflar arka planda kendi depolamamıza kopyalanır.</p>
      {st?.state && (
        <div className="mt-4 rounded-xl bg-[#FBF5F0] p-4 text-sm space-y-2" data-testid="legacy-import-status">
          <p className="flex items-center gap-2 font-medium text-[#2A2224]">
            {running ? <Loader2 className="w-4 h-4 animate-spin text-[#9E2A3B]" /> : <CheckCircle2 className="w-4 h-4 text-emerald-600" />}
            {st.state === "importing" ? "Firmalar ekleniyor…" : st.state === "copying" ? "Fotoğraflar kopyalanıyor…" : "Aktarım tamamlandı"}
          </p>
          <p className="text-[#5b4d4f]">Aktarılan firma: <b data-testid="legacy-firms-count">{(st.legacyFirms || 0).toLocaleString("tr-TR")}</b> · Fotoğraf: <b data-testid="legacy-images-done">{(st.imagesDone || 0).toLocaleString("tr-TR")}</b> / {(st.imagesTotal || 0).toLocaleString("tr-TR")}{st.imagesFailed ? ` (${st.imagesFailed.toLocaleString("tr-TR")} bulunamadı)` : ""}</p>
          <div className="h-2 rounded-full bg-[#F0DDE0] overflow-hidden"><div className="h-full bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
        </div>
      )}
      {!running && !(st?.legacyFirms > 0) && (
        <div className="mt-5 flex flex-wrap items-center gap-3">
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Patron şifreniz" className="max-w-[220px]" data-testid="legacy-import-password" />
          <label className="flex items-center gap-2 text-sm text-[#5b4d4f]">
            <input type="checkbox" checked={replace} onChange={(e) => setReplace(e.target.checked)} className="w-4 h-4 accent-[#9E2A3B]" data-testid="legacy-import-replace" />
            Şu anki diğer firmaları sil
          </label>
          <button onClick={start} disabled={!password || busy} data-testid="legacy-import-start" className="inline-flex items-center gap-2 px-4 h-10 rounded-xl bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] text-white text-sm font-medium disabled:opacity-50">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Database className="w-4 h-4" />} Aktarımı Başlat
          </button>
        </div>
      )}
    </div>
  );
};
